import { useMutation } from '@tanstack/react-query';
import { API_ROUTES } from '../constants/apiRoutes';
import type { BetBuilderCalculateRequest, BetBuilderCalculateResponse } from '../types/betBuilder';
import { postData } from '../utils/api';

type CalculateBetBuilderVariables = {
  eventId: string;
  payload: BetBuilderCalculateRequest;
};

export const useCalculateBetBuilder = () =>
  useMutation({
    mutationFn: ({ eventId, payload }: CalculateBetBuilderVariables): Promise<BetBuilderCalculateResponse> =>
      postData(API_ROUTES.BET_BUILDER.CALCULATE(eventId), payload),
  });
